module.exports = __webpack_public_path__ + "./img/file.cc0eca67104a4a08a6d5f9d23a1b0295.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/file.png
// module id = ./assets/images/file.png
// module chunks = 0